import React from "react";
import PropTypes from "prop-types";
import "../css/Navbar.css";
import Logo from "../images/LogoDiane.svg";
import Headroom from "headroom.js";

/**
 * Navbar component
 */
class Navbar extends React.Component {
  static displayName = "Navbar";
  static propTypes = {
    className: PropTypes.string,
  };
  static defaultProps = {};

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = "Navbar";
  }

  componentDidMount() {
    this.headroom = new Headroom(this.navbar);
    this.headroom.init();
  }

  componentWillUnmount() {
    this.headroom.destroy();
  }

  /**
   * @override
   */
  render() {
    return (
      <div
        className={`${this.className} ${this.props.className || ""}`}
        ref={n => (this.navbar = n)}
      >
        <div
          className={`${this.className}__goTop`}
          onClick={() => this.props.goTo("top")}
        />
        <div className={`${this.className}__logo`}>
          <img src={Logo} alt="Logo DPR" />
        </div>
        <div className={`${this.className}__slogan`}>Consulting Firm</div>
        <div className={`${this.className}__actions`}>
          {/* <div
            className={`${this.className}__lang`}
            onClick={this.props.switchLang}
          >
            {capitalize(this.props.lang === "en" ? "fr" : "en")}
          </div> */}
          <div
            className={`${this.className}__menu`}
            onClick={this.props.openMenu}
          >
            <svg viewBox="0 0 24 24">
              <path
                fill="#ff0028"
                d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z"
              />
            </svg>
          </div>
        </div>
      </div>
    );
  }
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar.js